import React, { useState } from "react";
import { useTranslation } from "react-i18next";
import { useNavigate } from "react-router-dom";
import "./styles.css";
import {
  getCategories
} from "../../api/FlaskAPI";
import { useDispatch } from "react-redux";
import { setCategories } from "../../reducers/CategoriesSlice";
import useApi from "../../hooks/useApi";
import { toast } from "react-toastify";
import LoadingProgress from "../LoadingProgress";

export default function ExploreBtn({ text }) {
  const { t } = useTranslation();
  const dispatch = useDispatch()
  const navigateToRoute = useNavigate();
  const categories = useApi(getCategories);
  const [showLoading, setShowLoading] = useState(false);
  const user = localStorage.getItem("user");

  const navigate = async () => {
    if(!user) {
      navigateToRoute("/account");
      return;
    }
    setShowLoading(true);
    try {
      const res = await categories.request({
        index: "ndvi"
      }, false);
      console.log("categories response:", res)
      dispatch(setCategories(res.data));
      localStorage.setItem("categories", JSON.stringify(res.data));
    } catch (error) {
      console.log(error);
      toast.error("Failed fetching index");
      setShowLoading(false);
      return;
    }
  };

  const handleLoadingComplete = () => {
    setShowLoading(false);
    navigateToRoute("/map");
  };

  if (showLoading) {
    return <LoadingProgress onComplete={handleLoadingComplete} />;
  }

  return (
    <button className="explorebtn" onClick={() => navigate()}>
      {text}
      <div className="star-1">
        <svg
          viewBox="0 0 784.11 815.53"
          className="shape-rendering:geometricPrecision; text-rendering:geometricPrecision; image-rendering:optimizeQuality; fill-rule:evenodd; clip-rule:evenodd"
          version="1.1"
        >
          <defs></defs>
          <g id="Layer_x0020_1">
            <metadata id="CorelCorpID_0Corel-Layer"></metadata>
            <path
              d="M392.05 0c-20.9,210.08 -184.06,378.41 -392.05,407.78 207.96,29.37 371.12,197.68 392.05,407.74 20.93,-210.06 184.09,-378.37 392.05,-407.74 -207.98,-29.38 -371.16,-197.69 -392.06,-407.78z"
              className="fil0"
            ></path>
          </g>
        </svg>
      </div>
      <div className="star-2">
        <svg
          viewBox="0 0 784.11 815.53"
          className="shape-rendering:geometricPrecision; text-rendering:geometricPrecision; image-rendering:optimizeQuality; fill-rule:evenodd; clip-rule:evenodd"
          version="1.1"
        >
          <defs></defs>
          <g id="Layer_x0020_1">
            <metadata id="CorelCorpID_0Corel-Layer"></metadata>
            <path
              d="M392.05 0c-20.9,210.08 -184.06,378.41 -392.05,407.78 207.96,29.37 371.12,197.68 392.05,407.74 20.93,-210.06 184.09,-378.37 392.05,-407.74 -207.98,-29.38 -371.16,-197.69 -392.06,-407.78z"
              className="fil0"
            ></path>
          </g>
        </svg>
      </div>
      <div className="star-3">
        <svg
          viewBox="0 0 784.11 815.53"
          className="shape-rendering:geometricPrecision; text-rendering:geometricPrecision; image-rendering:optimizeQuality; fill-rule:evenodd; clip-rule:evenodd"
          version="1.1"
        >
          <defs></defs>
          <g id="Layer_x0020_1">
            <metadata id="CorelCorpID_0Corel-Layer"></metadata>
            <path
              d="M392.05 0c-20.9,210.08 -184.06,378.41 -392.05,407.78 207.96,29.37 371.12,197.68 392.05,407.74 20.93,-210.06 184.09,-378.37 392.05,-407.74 -207.98,-29.38 -371.16,-197.69 -392.06,-407.78z"
              className="fil0"
            ></path>
          </g>
        </svg>
      </div>
      <div className="star-4">
        <svg
          viewBox="0 0 784.11 815.53"
          className="shape-rendering:geometricPrecision; text-rendering:geometricPrecision; image-rendering:optimizeQuality; fill-rule:evenodd; clip-rule:evenodd"
          version="1.1"
        >
          <defs></defs>
          <g id="Layer_x0020_1">
            <metadata id="CorelCorpID_0Corel-Layer"></metadata>
            <path
              d="M392.05 0c-20.9,210.08 -184.06,378.41 -392.05,407.78 207.96,29.37 371.12,197.68 392.05,407.74 20.93,-210.06 184.09,-378.37 392.05,-407.74 -207.98,-29.38 -371.16,-197.69 -392.06,-407.78z"
              className="fil0"
            ></path>
          </g>
        </svg>
      </div>
      <div className="star-5">
        <svg
          viewBox="0 0 784.11 815.53"
          className="shape-rendering:geometricPrecision; text-rendering:geometricPrecision; image-rendering:optimizeQuality; fill-rule:evenodd; clip-rule:evenodd"
          version="1.1"
        >
          <defs></defs>
          <g id="Layer_x0020_1">
            <metadata id="CorelCorpID_0Corel-Layer"></metadata>
            <path
              d="M392.05 0c-20.9,210.08 -184.06,378.41 -392.05,407.78 207.96,29.37 371.12,197.68 392.05,407.74 20.93,-210.06 184.09,-378.37 392.05,-407.74 -207.98,-29.38 -371.16,-197.69 -392.06,-407.78z"
              className="fil0"
            ></path>
          </g>
        </svg>
      </div>
      <div className="star-6">
        <svg
          viewBox="0 0 784.11 815.53"
          className="shape-rendering:geometricPrecision; text-rendering:geometricPrecision; image-rendering:optimizeQuality; fill-rule:evenodd; clip-rule:evenodd"
          version="1.1"
        >
          <defs></defs>
          <g id="Layer_x0020_1">
            <metadata id="CorelCorpID_0Corel-Layer"></metadata>
            <path
              d="M392.05 0c-20.9,210.08 -184.06,378.41 -392.05,407.78 207.96,29.37 371.12,197.68 392.05,407.74 20.93,-210.06 184.09,-378.37 392.05,-407.74 -207.98,-29.38 -371.16,-197.69 -392.06,-407.78z"
              className="fil0"
            ></path>
          </g>
        </svg>
      </div>
    </button>
  );
}
